const BreadcrumbsContainer = ({ children }) => <section className="oc-utility-bar">{children}</section>;

export default BreadcrumbsContainer;
